export default __webpack_public_path__ + "static/badge-color-light-d817c8c8b7ade278f3a5d9fbdad5f68e.png";